
import { useEffect, useMemo } from "react";
import { selectAwards } from "../Selectors/AwardsSelectors";
import { awardsActions } from "../Store/AwardsSlice";
import { getAwards } from "./Api";
import { useDispatch, useSelector } from "react-redux";

export function useAwards() {
    const dispatch = useDispatch();
    
    const awards = useSelector(selectAwards);

    useEffect(() => {
        if(awards) return;

        // Getting Awards from Award endpoint.
        getAwards()
            .then((awardsResp) => {
                if (awardsResp.awards !== null && awardsResp.status === 'OK') {
                    dispatch(awardsActions.setAwards({ awards: awardsResp.awards }));
                }
            });
    }, [dispatch, awards]);

    return awards;
}

export function useActiveAwards() {
    const awards = useAwards();

    const activeAwards = useMemo(() => {
        return awards?.filter(award => award.openForViewing);
    }, [awards]);

    return activeAwards;
}